import { render, staticRenderFns } from "./IndexTwoRow.vue?vue&type=template&id=5617055a&scoped=true"
import script from "./IndexTwoRow.vue?vue&type=script&lang=js"
export * from "./IndexTwoRow.vue?vue&type=script&lang=js"
import style0 from "./IndexTwoRow.vue?vue&type=style&index=0&id=5617055a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5617055a",
  null
  
)

export default component.exports